var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-progress-circular',{attrs:{"indeterminate":"","size":_vm.size,"color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }